<template lang="pug">
  .ProjectDesign
    h1(:class="titleAnimation") 方案设计
    div(:class="contentAnimation")
      div
        .bigBule "
        p {{ text }}
        button 立即体验
        
</template>

<script>
  import Mixin from "../../index.js";
  export default {
    name: "ProjectDesign",
    mixins: [Mixin],
    props: {
      text: String,
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .ProjectDesign {
    VStack(center, center)
    padding 100px 0
    >div {
      background-color #f8f8f8
      padding 20px
      max-width 80%
      
      >div {
        position relative
        padding-left 30px
        VStack(center, center)
        &::before {
          content ""
          border-top 1px solid #bababa
          border-left 1px solid #bababa
          top 0
          left 0
        }
        &::after {
          content ""
          border-bottom 1px solid #bababa
          border-right 1px solid #bababa
          bottom 0
          right 0
        }
        &::before, &::after {
          width 154px
          height 134px
          position absolute
        }
        p {
          font-size 18px
          line-height 36px
          color #202020
          FontSetting("思源黑体 CN Normal")
          letter-spacing 1.4px
          max-width 1200px
        }
        button {
          background-color #269bff
          color white
          FontSetting("思源黑体 CN Regular")
          font-size 16px
          height 38px
          width 126px
          border-radius 19px
          border none
          outline none
          HStack(center, center)
          transition all .3s
          &:hover {
            transform scale(1.1)
          }
        }
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      > div {
        > div {
          padding 0 20px 20px
        }
      }
    }
  }
  .bigBule {
    font-size 106px
    FontSetting(Lora)
    font-weight 400
    color #269bff
    margin-bottom -76px
    align-self flex-start
  }
</style>
